import React, { useEffect, useReducer } from 'react';
import { BreadCrumb, FooterSection } from '../components';
import './../../styles/irctcForgotPasswordPage.css';
import './../../styles/UpdateCenterCommon.css';
import GetIrctcPassword from './components/GetIrctcPassword';
import SimilarQuestions from '../components/SimilarQuestions';
import IrctcFaq from '../components/IrctcFaq';
import IrctcPasswordSent from './components/IrctcPasswordSent';
import { FirstBookingPersuation } from '../components/FirstBookingPersuation';
import {
  FOOTER_DATA_IRCTC,
  IRCTC_BREAD_CRUMB_COMMON,
  IRCTC_EXTERNAL_JS,
  IRCTC_FAQ_TITLE,
  IRCTC_FORGOT_PASSWORD_COMPONENTS,
  SIMILAR_QUESTIONS_TITLE
} from '../../utils/RailsSEOConstants';
import { irctcForgotPasswordInitialState, irctcForgotPasswordReducer } from '../../reducers/irctcForgotPassowrdReducer';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import HtmlHeader from '../components/HtmlHeader';
import AdWrapper from '../components/AdWrapper';
import { AD_PAGES } from '../../utils/adsUtils';
import PropTypes from 'prop-types';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import { TrainClasses } from '../route_info/TrainClasses';
import { IRCTC_INFO_PAGE_EVENT } from '../../analytics/constants';
import { logIrctcInfoPageLoadEvent } from '../../analytics/events/logIrctcInfoPageLoadEvent';

const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);
export const IrctcForgotPasswordContext = React.createContext<any>(irctcForgotPasswordInitialState);

const IrctcForgotPasswordPage = (props) => {
  const { data } = props;
  const [state, dispatch] = useReducer(irctcForgotPasswordReducer, irctcForgotPasswordInitialState);
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const { componentToShow } = state;
  const {
    template: { h1_title: IRCTC_FORGOT_PASSWORD_TITLE }
  } = data;

  useEffect(() => {
    if (typeof window !== 'undefined' && data) {
      logIrctcInfoPageLoadEvent(IRCTC_INFO_PAGE_EVENT.FORGOT_PASSWORD);
    }
  }, []);

  return (
    <IrctcForgotPasswordContext.Provider value={{ forgotPasswordState: state, forgotPasswordDispatch: dispatch }}>
      <HtmlHeader data={data} />
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>
      <main className="container irctcLogin">
        <div className={`append_bottom30 appendTop30`}>
          <AdWrapper adsPageName={AD_PAGES.IRCTC_FORGOT_PASSWORD_PAGE.adsPageName} />
        </div>
        <div className="appendBottom20">
          <BreadCrumb breadcrumb={data.template.breadcrumb} noLeftPadding />
        </div>
        <h1 className={'appendBottom15 font24'}>{IRCTC_FORGOT_PASSWORD_TITLE}</h1>
        {componentToShow === IRCTC_FORGOT_PASSWORD_COMPONENTS.inputForm && (
          <GetIrctcPassword customClass="appendBottom40" />
        )}
        {componentToShow === IRCTC_FORGOT_PASSWORD_COMPONENTS.successPage && (
          <IrctcPasswordSent customClass="appendBottom40" />
        )}
        <FirstBookingPersuation />
        <h2>{SIMILAR_QUESTIONS_TITLE}</h2>
        <SimilarQuestions customClass="appendBottom40" />
        <h2>{IRCTC_FAQ_TITLE}</h2>
        <IrctcFaq customClass="appendBottom40" />
      </main>
      <FooterSection template={data.template} />
    </IrctcForgotPasswordContext.Provider>
  );
};

IrctcForgotPasswordPage.propTypes = {
  data: PropTypes.object
};

IrctcForgotPasswordPage.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: `irctc-forgot-password`,
    meta_title: `IRCTC Forgot Password - How to Recover Your IRCTC Password for IRCTC Login`,
    meta_description: `Need to reset your IRCTC password? Follow the simple step-by-step guide on how to recover IRCTC password.`,
    meta_keywords: `IRCTC forgot password, forgot password for IRCTC, irctc password change,irctc login, IRCTC Registration`,
    analytics: getStaticPageLoadEvent(IRCTC_INFO_PAGE_EVENT.FORGOT_PASSWORD),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `IRCTC Forgot Password`,
    breadcrumb: [
      ...IRCTC_BREAD_CRUMB_COMMON,
      {
        displayString: `IRCTC Forgot Password`,
        redirectionUrl: `https://www.makemytrip.com/railways/irctc-forgot-password.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/irctc-forgot-password.html`,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };

  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_IRCTC-FORGOT-PASSWORD.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};
export default IrctcForgotPasswordPage;
